import { FetchStatus } from '../types'

export enum RemoteEnumsKey {
  PAYMENT_CHANNEL = 'PAYMENT_CHANNEL',
}

export interface EnumsState {
  fetchStatus: Record<RemoteEnumsKey, FetchStatus>
  enums: Record<RemoteEnumsKey, defs.EnumDto[] | null>
}

export type ActionFetchEnums = (key: RemoteEnumsKey) => Promise<void>
